import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginSuccess } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/connexion");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        loginSuccess(data);
        window.history.replaceState(null, "", "/tableau-de-bord");
        navigate("/tableau-de-bord", { replace: true });
      } catch {
        navigate("/connexion", { replace: true });
      }
    })();
  }, [navigate, loginSuccess]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F9F6F0] gap-4">
      <div className="h-12 w-12 rounded-full border-4 border-[#E85D04]/30 border-t-[#E85D04] animate-spin" />
      <p className="text-[#5C574F] font-medium">Connexion en cours…</p>
    </div>
  );
}
